/* global module */

'use strict';

const urlHelper = require('friartux/utils/urlHelper');
const createErrorNotification = require('friartux/components/errorNotification');
const createInfoNotification = require('friartux/components/infoNotification');
const curatedProduct = require('friartux/product/curatedProduct');
const search = require('friartux/search/search');
const scrollAnimate = require('base/components/scrollAnimate');
const savedLooks = require('friartux/components/savedLooks');
const { handleCustomLookNameInit } = require('friartux/components/handleCustomLookName');
const { handleDeleteLook } = require('friartux/components/handleDeleteLook');
const { handleFtoViewLook } = require('friartux/components/handleFtoViewLook');
const { handleLoadSavedLook } = require('friartux/components/handleLoadSavedLook');
const { initLooksImagesObserver } = require('friartux/components/looksImagesObserver');

const { CLASSES } = require('friartux/utils/globals');
const SELECTORS = {
    body: 'body',
    lookBuilder: '.js-lookbuilder',
    customLookNameContainer: '.js-custom-look-name-container',
    customLookNameBtn: '.js-custom-look-name-btn',
    generalErrorContainer: '.error-messaging',
    customLookNameModalContent: '.js-custom-look-name-modal-product-container',
    checkoutBtn: '.js-checkout-btn',
    cardsList: '.js-cards-list',
    selectedProductsContainer: '.js-selected-products',
    selectedProducts: '.js-selected-products .js-selected-product-row',
    sizeChangeBtn: '.js-size-change',
    notAvailableForDateError: '.js-not-available-for-date-error',
    addAll: '.js-add-all-recommendations',
    removeAllBtn: '.js-remove-all-line-items',
    miniPlpContainer: '.js-mini-plp-container',
    lbFooter: '.js-lb-footer',
    additionalProductContainer: '.js-additional-container',
    addAdditionalBtn: '.js-add-additional-btn',
    additionalProduct: '.js-additional-product',
    additionalProductConfig: '.js-additional-product-config',
    additionalCategory: '.js-add-category',
    additionalItemInfo: '.js-cart-additional-items-info',
    closeAdditionalCategoryBtn: '.js-close-additional-cat-btn',
    mainSelection: '.js-main-selection',
    mainSelectionBackBtn: '.js-back-btn',
    openCategoryWrapper: '.js-open-cat-wrapper',
    openCategory: '.js-open-cat',
    recommendedItems: '.js-recommended-items',
    recommendationBtn: '.recommendation-btn',
    listCard: '.list-card',
    tabFooter: '.tab-footer',
    buttonContainer: '.button-container',
    footerContent: '#footercontent',
    isPrimaryProductInput: '.js-primary-product',
    setMainProductBtn: '.js-set-main-product-btn',
    setMainProductModalBtn: '.js-open-set-product-modal',
    attrSelectContainer: '.js-attr-select-container',
    attrSelectModal: '.js-attribute-select-modal',
    attrSelectSubmitBtn: '.js-cart-attr-submit',
    attrProduct: '.js-attr-product',
    totalPrice: '.js-total-price',
    aiTryOnCartWrapper: '.js-aitryon-cart-wrapper',
    aiTryOnExcludedMessage: '.js-aitryon-excluded-message'
};

function init() {
    $(SELECTORS.body).on('click', SELECTORS.removeAllBtn, handleRemoveAllBtnClick);
    $(SELECTORS.body).on('click', SELECTORS.addAll, handleAddAllBtnClick);
    $(SELECTORS.body).on('click', SELECTORS.addAdditionalBtn, handleAddAdditionalBtn);
    $(SELECTORS.body).on('click', SELECTORS.closeAdditionalCategoryBtn, handleCloseAdditionalCategoryBtn);
    $(SELECTORS.body).on('click', SELECTORS.openCategory, handleOpenCategory);
    $(SELECTORS.body).on('click', SELECTORS.selectedProducts, handleSelectedProducts);
    $(SELECTORS.body).on('click', SELECTORS.checkoutBtn, handleCheckoutBtn);
    $(SELECTORS.body).on('click', SELECTORS.setMainProductModalBtn, handleSetMainProductModalBtn);
    $(SELECTORS.body).on('click', SELECTORS.setMainProductBtn, handleSetMainProductButton);
    $(SELECTORS.body).on('click', SELECTORS.additionalProduct, handleAdditionalProduct);
    $(SELECTORS.body).on('click', SELECTORS.attrSelectSubmitBtn, handleAttrSelectSubmit);
    $(SELECTORS.recommendedItems).on('click', SELECTORS.recommendationBtn, handleRecommendationBtn);
    $(SELECTORS.body).on('keyup', SELECTORS.additionalProduct, handleAdditionalProductKeyUp);

    handleCustomLookNameInit();
    handleDeleteLook();
    handleFtoViewLook();
    handleLoadSavedLook();
    initLooksImagesObserver();
    initSocMedLinks();
    initStickyness();
    savedLooks.init();
    $(SELECTORS.body).on('savedLooks:paginate', function() {
        initLooksImagesObserver();
    });
}

/**
 * Initialize mini PLP.
 */
function initMiniPlp() {
    $(SELECTORS.miniPlpContainer).on('click', '.refinement-btn', (e) => {
        let $this = $(e.currentTarget);
        let href = $this.data('href');
        if (!$this.hasClass('disabled') && href !== '#') {
            let context = getMiniPlpContext($this);
            // @todo: Move this to attribute refinement value.
            href = href.replace('ShowAjax', 'ShowMiniAjax');
            href += '&isMiniPLP=true';
            showMiniPlp(href, null, true, context);
        }
    });

    $(SELECTORS.miniPlpContainer).on('click', SELECTORS.mainSelectionBackBtn, () => {
        $(SELECTORS.miniPlpContainer)
            .data('remove-uuid', null)
            .slideUp('fast');
        $(SELECTORS.tabFooter).slideDown('fast');
        $(SELECTORS.listCard).slideDown('fast');
        $(SELECTORS.buttonContainer).css('opacity','1');
        $(SELECTORS.lbFooter).hide();
        $(SELECTORS.additionalProductContainer).find(SELECTORS.listCard).not('.show').hide();
    });

    $(SELECTORS.miniPlpContainer).on('click', '.js-mini-plp-product-tile > .product', (e) => {
        let $this = $(e.currentTarget);
        $this.find('.quickview')[0].click();
    });

    $(SELECTORS.miniPlpContainer).on('click', '.image-container a, .pdp-link > a', (e) => {
        e.preventDefault();
    });
}

/**
 * Implements hook product:afterAddToCart.
 */
function afterAddToCart() {
    $('body').on('product:afterAddToCart', (e, data) => {
        if (!data.error && !data.modalTemplate) {
            $('body').trigger('cart:update', data);
            if (isTabletOrMobileWidth()) {
                $(SELECTORS.lookBuilder)[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    });
}

/**
 * Implements hook cart:update.
 */
function cartUpdate() {
    $('body').on('cart:update', (e, response) => {
        var cart;

        if (typeof response !== 'undefined' && response.renderedCart) {
            cart = $(response.renderedCart);
        } else {
            let ajaxUrl = $(SELECTORS.lookBuilder).data('ajax-url');
            $.ajax({
                url: ajaxUrl,
                method: 'GET',
                success: (data) => {
                    if (data) {
                        cart = $(data);
                    }
                    updateLookBuilder(cart);
                },
                error: () => {
                    $.spinner().stop();
                    createErrorNotification($(SELECTORS.generalErrorContainer), response.message);
                }
            });
        }

        if (cart) {
            updateLookBuilder(cart);
        }
    });
}

/**
 * Refresh and update the look builder components.
 */
function updateLookBuilder(cart) {
    $(SELECTORS.mainSelectionBackBtn).trigger('click');

    updateLookImages(cart);
    updateAdditionalItems(cart);
    updateAttrSelectModal(cart);

    $(SELECTORS.selectedProductsContainer).html(cart.find(SELECTORS.selectedProductsContainer).html());
    $(SELECTORS.mainSelection).find(SELECTORS.openCategoryWrapper).html(cart.find(SELECTORS.openCategoryWrapper).html());
    $(SELECTORS.recommendedItems).html(cart.find(SELECTORS.recommendedItems).html());
    $(SELECTORS.totalPrice).html(cart.find(SELECTORS.totalPrice).html());

    // Refresh the "Try on with AI" trigger visibility to match the updated cart
    // (e.g. a coat with allowAI was just added/removed). The modal itself is
    // rendered once on page load and is not re-rendered here, so its dynamic
    // parts (the excluded-items notice) are refreshed individually below.
    var $aiTryOnCartWrapper = $(SELECTORS.aiTryOnCartWrapper);
    $aiTryOnCartWrapper.html(cart.find(SELECTORS.aiTryOnCartWrapper).html());
    // Keep the trigger last inside the look builder — updateAdditionalItems() can
    // append the additional-items container after it on the first additional add.
    $(SELECTORS.lookBuilder).append($aiTryOnCartWrapper);
    $(SELECTORS.aiTryOnExcludedMessage).html(cart.find(SELECTORS.aiTryOnExcludedMessage).html());

    $(SELECTORS.body).trigger('select:reInit');

    $(SELECTORS.customLookNameModalContent).html(cart.find(SELECTORS.customLookNameModalContent).html());
    $(SELECTORS.customLookNameContainer).html(cart.find(SELECTORS.customLookNameContainer).html());
    $(SELECTORS.customLookNameBtn)[cart.find('.js-selected-product-row').length > 0 ? 'removeClass' : 'addClass'](CLASSES.hide);
    $(SELECTORS.checkoutBtn)[cart.find('.js-selected-product-row').length > 0 ? 'removeClass' : 'addClass'](CLASSES.disabled);
    $(SELECTORS.removeAllBtn)[cart.find('.js-selected-product-row').length > 0 ? 'removeClass' : 'addClass'](CLASSES.hide);
}

/**
 * Update dynamic look images.
 * @param {*} cart
 */
function updateLookImages(cart) {
    let thumbnailContainerSelector = '.c-lb-thumbnails';
    let cartThumbnailImages = cart.find(thumbnailContainerSelector);

    // Remove existing thumbnails that are not on the new response.
    var currentThumbnailImages = $(SELECTORS.lookBuilder).find(thumbnailContainerSelector);
    currentThumbnailImages.children().each(function() {
        let thumbnailImage = $(this);
        let classes = thumbnailImage.attr('class');
        let thumbnailExist = cartThumbnailImages.find("div[class*='" + classes + "']").length > 0;

        if (!thumbnailExist) {
            thumbnailImage.remove();
        }
    });

    var prevThumbnail;
    // Update and create new thumbnails from response.
    cartThumbnailImages.children().each(function() {
        currentThumbnailImages = $(SELECTORS.lookBuilder).find(thumbnailContainerSelector);
        let thumbnailImage = $(this);
        let classes = thumbnailImage.attr('class');
        let currentThumbnail = currentThumbnailImages.find("div[class*='" + classes + "']");

        if (currentThumbnail.length > 0) {
            updateThumbnail(currentThumbnail, thumbnailImage);
        } else {
            if (prevThumbnail) {
                let lastThumbnail = currentThumbnailImages.find("div[class*='" + prevThumbnail.attr('class') + "']");
                thumbnailImage.insertAfter(lastThumbnail);
            } else {
                if (currentThumbnailImages.children().length > 0) {
                    currentThumbnailImages.append(thumbnailImage);
                } else {
                    currentThumbnailImages.prepend(thumbnailImage);
                }
            }
        }
        prevThumbnail = thumbnailImage;
    });
    currentThumbnailImages.tooltip('update');
}

/**
 * Update the existing image thumbnail
 * @param {*} thumbnail - Current thumbnail
 * @param {*} newThumbnail - New thumbnail
 */
function updateThumbnail(thumbnail, newThumbnail) {
    thumbnail
        .attr('data-pid', newThumbnail.attr('data-pid'))
        .attr('title', newThumbnail.attr('title'))
        .attr('data-original-title', newThumbnail.attr('title'));

    let newThumbnailImg = newThumbnail.find('img');
    thumbnail.find('img')
        .attr('src', newThumbnailImg.attr('src'))
        .attr('alt', newThumbnailImg.attr('alt'))
        .attr('onerror', newThumbnailImg.attr('onerror'));
}

/**
 * Update additional items section.
 * @param {*} cart
 */
function updateAdditionalItems(cart) {
    let additionalItemInfo = $(SELECTORS.additionalItemInfo).html();
    if ($(SELECTORS.additionalProductContainer).length < 1) {
        $(SELECTORS.lookBuilder).append(cart.find(SELECTORS.additionalProductContainer))
    } else {
        $(SELECTORS.additionalProductContainer).html(cart.find(SELECTORS.additionalProductContainer).html());
    }

    $(SELECTORS.additionalProductContainer).find('.tooltip').html(additionalItemInfo);
}

/**
 * Update attribute select items section.
 * @param {*} cart
 */
function updateAttrSelectModal(cart) {
    let showModal = cart.find(SELECTORS.attrSelectContainer).data('show');
    $(SELECTORS.attrSelectContainer).html(cart.find(SELECTORS.attrSelectContainer).html());
    $(SELECTORS.attrSelectContainer).data('show', showModal);

    if (showModal) {
        $.ajax({
            url: Urls.cartGetAttributeSelection,
            method: 'GET',
            success: (response) => {
                if (response) {
                    $(SELECTORS.attrSelectModal).find('.js-modal-body-content').html(response);
                    $(SELECTORS.body).trigger('select:reInit');
                }
            },
            error: () => {
                $.spinner().stop();
                createErrorNotification($(SELECTORS.generalErrorContainer), response.message);
            }
        });
    }
}

/**
 * Show the miniPLP component section.
 */
function showMiniPlp(url, formData, openFilter, context) {
    $(SELECTORS.cardsList).spinner().start();

    let $context = context;

    let ajaxObj = {
        url: url,
        method: 'GET',
        success: (data) => {
            $.spinner().stop();

            if (!data) {
                return;
            }

            // Hide other elements for main selection only
            $context.find(SELECTORS.listCard).slideUp('fast');
            $context.find(SELECTORS.tabFooter).slideUp('fast');
            $context.find(SELECTORS.buttonContainer).css('opacity','0');

            let filteredMiniPlp = $(data);
            if (openFilter !== undefined && openFilter) {
                filteredMiniPlp.find('#filters').addClass('show');
                filteredMiniPlp.find('.btn-filters').removeClass('collapsed');
            }

            $context.find(SELECTORS.miniPlpContainer).html(filteredMiniPlp);

            let recoIds = $(SELECTORS.recommendedItems).data('reco-ids');
            if (typeof(recoIds) === 'object' && recoIds !== null) {
                recoIds.forEach(pid => {
                    if (pid) {
                        filteredMiniPlp.find('.product[data-pid=' + pid + ']')
                            .parent()
                            .prependTo('.product-grid')
                            .find('.recommended')
                            .addClass('show');
                    }
                });
            }

            $(SELECTORS.lbFooter).show();
            $context.find(SELECTORS.miniPlpContainer).slideDown('fast', () => {
                if (isTabletOrMobileWidth()) {
                    $('.tab-heading')[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });

            initObserver();
            setTimeout(() => {
                $(SELECTORS.miniPlpContainer).get(0).scrollIntoView({
                    behavior: 'smooth'
                });
            }, 500);
        },
        error: () => {
            $.spinner().stop();
            // @todo: add error message display.
        }
    };

    if (formData !== undefined && formData) {
        ajaxObj.data = formData;
    }

    $.ajax(ajaxObj);
}

/**
 * Shows a confirmation popup to replace the current look builder.
 */
function promptCartReplacement() {
    // Check for look builder product replace.
    let $cartReplaceModal = $('#replaceProductModal');
    if ($cartReplaceModal.length > 0) {
        $cartReplaceModal.modal('show');
    }

    $('body').on('click', '.js-cart-replace-items-confirmation-btn', () => {
        window.location = $('#confirmReplace').data('url');
    });
}

function shareUrlUpdate() {
    var shareURL = $(SELECTORS.lookBuilder).data('shareurl');
    var shareImg;
    var pids = [];
    $(SELECTORS.selectedProducts).each(function() {
        var $this = $(this);
        var currPID = $this.find('.product-info').data('prodid');
        var purchaseOption = $this.find('.product-info').data('purchase-option');
        var pid = currPID + '|' + purchaseOption;

        if (!shareImg) {
            shareImg = $this.find('img').first().attr('src');
        }

        pids.push(pid);
    });

    if (pids.length > 0) {
        pids = pids.join('+');
        shareURL = urlHelper.appendToUrl(shareURL, { sharedPids: pids });
    }

    return {
        shareURL: shareURL,
        shareImg: shareImg
    }
}

function isTabletOrMobileWidth() {
    return (window.innerWidth <= 1024);
}

/**
 * Get the miniPLP parent context/
 * @param {Dom Element} $elem
 * @returns
 */
function getMiniPlpContext($elem) {
    let context = $elem.parents(SELECTORS.additionalCategory);

    if (context.length <= 0) {
        context = $elem.parents(SELECTORS.mainSelection);
    }

    return context;
}

/**
 * Initialize lazy loading.
 */
function initObserver() {
    const $target = document.querySelector('.lazy-load-intersect');

    if ($target) {
        search.initObserver($target);
    }
}

/**
 * Initialize social media links and events.
 */
function initSocMedLinks() {
    $('.lb__main #js-facebook').on('click',function(e) {
        e.preventDefault();

        if ($(SELECTORS.selectedProducts).length <= 0) {
            return false;
        }

        var currHref = $(this).attr('href');
        var url = new URL(currHref);
        var lookbuilderData = shareUrlUpdate();
        var urlSearchParams = new URLSearchParams(url.search);
        urlSearchParams.set('u',lookbuilderData.shareURL);
        url.search = urlSearchParams.toString();
        window.open(url, '_blank');
    });

    $('.lb__main #js-twitter').on('click',function(e) {
        e.preventDefault();

        if ($(SELECTORS.selectedProducts).length <= 0) {
            return false;
        }

        var currHref = $(this).attr('href');
        var url = new URL(currHref);
        var lookbuilderData = shareUrlUpdate();
        var urlSearchParams = new URLSearchParams(url.search);
        urlSearchParams.set('url',lookbuilderData.shareURL);
        urlSearchParams.set('text','Look Builder');

        url.search = urlSearchParams.toString();
        window.open(url, '_blank');
    });

    $('.lb__main #js-pinterest').on('click',function(e) {
        e.preventDefault();

        if ($(SELECTORS.selectedProducts).length <= 0) {
            return false;
        }

        var currHref = $(this).attr('href');
        var url = new URL(currHref);
        var lookbuilderData = shareUrlUpdate();
        var urlSearchParams = new URLSearchParams(url.search);
        urlSearchParams.set('url',lookbuilderData.shareURL);
        urlSearchParams.set('media',lookbuilderData.shareImg);
        urlSearchParams.set('description','Look Builder');
        url.search = urlSearchParams.toString();
        window.open(url, '_blank');
    });
}

/**
 * Handle Remove all items button click
 * @returns {void}
 */
const handleRemoveAllBtnClick = (e) => {
    e.preventDefault();

    $(SELECTORS.cardsList).spinner().start();
    $.ajax({
        url: Urls.cartRemoveAllUrl,
        type: 'GET',
        dataType: 'json',
        success: (response) => {
            $.spinner().stop();

            if (response.redirectUrl) {
                window.location.href = response.redirectUrl;
            } else {
                $('body').trigger('cart:update');
            }

            if (response.error) {
                createErrorNotification($(SELECTORS.generalErrorContainer), response.errorMessage);
            }
        }
    });
}

const handleRecommendationBtn =  (e) => {
    let $this = $(e.currentTarget);
    let catId = $this.data('cgid');
    $(SELECTORS.mainSelectionBackBtn).find('.js-open-cat[data-cgid="' + catId + '"]').trigger('click');
}

const handleAddAdditionalBtn = () => {
    let $veil = $('<div class="veil-cover"><div class="underlay"></div></div>');
    $veil.insertBefore(SELECTORS.additionalCategory);
    $(SELECTORS.additionalCategory).toggleClass('show');
    $(SELECTORS.mainSelectionBackBtn).trigger('click');
    $(SELECTORS.body).css('overflow', 'hidden');
}

const handleCloseAdditionalCategoryBtn = () => {
    $(SELECTORS.additionalCategory).toggleClass('show');
    $('.veil-cover').remove();
    $(SELECTORS.body).css('overflow', 'auto');
}

const handleOpenCategory = (e) => {
    let $this = $(e.currentTarget);
    let catId = $this.data('cgid');
    let url = $(SELECTORS.openCategoryWrapper).data('mini-url');
    let formData = {
        cgid: catId,
        isMiniPLP: true
    };

    let context = getMiniPlpContext($this);
    $(SELECTORS.isPrimaryProductInput).val(false);
    showMiniPlp(url, formData, false, context);
}

/**
 * Handle Add all recommendations button click
 * @returns {void}
 */
const handleAddAllBtnClick = (e) => {
    e.preventDefault();

    const $messageContainer = $(SELECTORS.generalErrorContainer);
    // updateLookBuilder does not re-render this container, so drop any toast left over from a
    // previous action to keep the outcome of this click unambiguous.
    $messageContainer.empty();

    $(SELECTORS.cardsList).spinner().start();
    $.ajax({
        url: Urls.addAllRecommendations,
        type: 'POST',
        dataType: 'json',
        data: {
            // currentTarget, not target: the button wraps an <img class="plus-icon"> and a
            // click on the glyph would otherwise send an empty recoInfo.
            recoInfo: JSON.stringify($(e.currentTarget).data('reco-info'))
        },
        success: (response) => {
            $.spinner().stop();
            $('body').trigger('cart:update', response);

            if (response.error) {
                const errorMessage = response.message ? response.message : response.errorMessage;
                createErrorNotification($messageContainer, errorMessage);
            } else if (response.infoMessage) {
                createInfoNotification($messageContainer, response.infoMessage);
            }
        },
        error: (xhr) => {
            // A non-2xx response never reaches success(), so release the spinner here.
            $.spinner().stop();

            const errorMessage = xhr.responseJSON && xhr.responseJSON.errorMessage;
            if (errorMessage) {
                createErrorNotification($messageContainer, errorMessage);
            }
        }
    });
}

/**
 * Event handle for selected products click event.
 * @param {Event} e
 */
const handleSelectedProducts = (e) => {
    if ($(e.target).hasClass('trash-icon')
        || $(e.target).hasClass('remove-product')
        || $(e.target).closest(SELECTORS.sizeChangeBtn).length > 0) {
        return;
    }

    let $this = $(e.currentTarget);
    let $productInfo = $this.find('.product-info');
    let pid = $productInfo.data('prodid');
    let catId = $productInfo.data('cgid');
    let uuid = $productInfo.data('uuid');
    let url = $(SELECTORS.openCategoryWrapper).data('mini-url');

    let formData = {
        selectedPid: pid,
        cgid: catId,
        isMiniPLP: true
    };

    let context = getMiniPlpContext($this);
    $(SELECTORS.isPrimaryProductInput).val(true);
    showMiniPlp(url, formData, false, context);
    $(SELECTORS.miniPlpContainer).data('remove-uuid', uuid);
}

/**
 * Event handle for Checkout button click event.
 * @param {Event} e
 * @returns
 */
const handleCheckoutBtn = (e) => {
    e.preventDefault();

    let readyToCheckout = true;
    let showAttrSelectionModal = $(SELECTORS.attrSelectContainer).data('show');

    if (showAttrSelectionModal) {
        $(SELECTORS.attrSelectModal).modal('show');
        readyToCheckout = false;
    }

    $(SELECTORS.selectedProducts).each(function (index, product) {
        if ($(product).attr('data-is-buy-ready-for-order') && $(product).attr('data-is-buy-ready-for-order') === 'false') {
            readyToCheckout = false;
        }
    });

    if ($(SELECTORS.notAvailableForDateError).length) {
        readyToCheckout = false;
    }

    if (readyToCheckout) {
        window.location.href = $(SELECTORS.checkoutBtn).attr('href');
        return;
    } else {
        scrollAnimate();
    }
}

const handleAdditionalProduct = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);

    let $productConfig = $this.find(SELECTORS.additionalProductConfig);

    if (!$productConfig.hasClass('show')) {
        $(SELECTORS.additionalProductConfig).removeClass('show').slideUp('fast');
        $productConfig
            .attr('aria-expanded', 'true')
            .addClass('show').slideDown('fast');
        $(SELECTORS.additionalProductContainer).addClass(CLASSES.expanded);
        $this.attr('aria-expanded', 'true');
    } else {
        $(SELECTORS.additionalProductConfig).attr('aria-expanded', 'false').removeClass('show').slideUp('fast');
        $(SELECTORS.additionalProductContainer).removeClass(CLASSES.expanded);
        $(SELECTORS.additionalProduct).attr('aria-expanded', 'false');
    }

}

const handleAttrSelectSubmit = (e) => {
    e.preventDefault();
    $.spinner().start();

    let formData = [];
    let updateLineItemUrl = $(SELECTORS.attrSelectContainer).data('url');
    let readyToSubmit = true;

    let $attrProducts = $(SELECTORS.attrProduct);
    $attrProducts.each(function (i) {
        let $attrProductLine = $($(SELECTORS.attrProduct).get(i));
        let uuid = $attrProductLine.data('uuid');
        let newPid = $attrProductLine.find('.js-attr-product-line').data('pid');
        let originalPid = $attrProductLine.data('original-pid');

        if (!newPid || newPid === originalPid) {
            $.spinner().stop();
            readyToSubmit = false;
            $attrProductLine.find('.pdp-variation-select').addClass('is-invalid');
            $attrProductLine[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            return readyToSubmit;
        } else {
            $attrProductLine.find('.pdp-variation-select').removeClass('is-invalid');
        }

        let lineItemData = {
            uuid: uuid,
            newPid: newPid,
            originalPid: originalPid
        }
        formData.push(lineItemData);
    })

    if (!readyToSubmit) {
        return;
    }

    $.ajax({
        url: updateLineItemUrl,
        method: 'POST',
        data: {
            lineItems: JSON.stringify(formData)
        },
        success: function (response) {
            $.spinner().stop();
            $('body').trigger('cart:update', response);

            if (response.error) {
                $.spinner().stop();
                // Prevent multiple error message display.
                $('.alert.valid-cart-error').remove();
                createErrorNotification($(SELECTORS.generalErrorContainer), response.message);

                return;
            }

        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($(SELECTORS.generalErrorContainer), err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });

}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
const handleSetMainProductModalBtn = (e) => {
    e.preventDefault();
    let $this = $(e.currentTarget);
    var $productToSetSpan = $('.js-product-to-set-main');

    let pName = $this.closest(SELECTORS.listCard).find('.name').text();
    $productToSetSpan.text(pName);
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
const handleSetMainProductButton = (e) => {
    e.preventDefault();
    let $this = $(e.currentTarget);

    e.preventDefault();

    var productID = $this.data('pid');
    var url = $this.data('action');
    var uuid = $this.data('uuid');
    var urlParams = {
        pid: productID,
        uuid: uuid
    };

    url = urlHelper.appendToUrl(url, urlParams);

    $.spinner().start();

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $(SELECTORS.body).trigger('cart:update', data);
            $.spinner().stop();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($(SELECTORS.generalErrorContainer), err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });
}

const handleAdditionalProductKeyUp = (e) => {
  var $this = $(e.target);

  if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
    $this.trigger('click');
  }
}

function initStickyness() {
    const el = document.querySelector('.sticky-bottom-container');
    if (el) {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
            { threshold: [1] }
        );

        observer.observe(el);
    }
}

module.exports = {
    init,
    initMiniPlp,
    afterAddToCart,
    cartUpdate,
    promptCartReplacement,
    handleReplaceCuratedProduct: curatedProduct.handleReplaceCuratedProduct
};
